import WithDrawer from './WithDrawer.component';

export default WithDrawer;
